import { format as formatDate, isValid as isValidDate } from 'date-fns';

export const isObjectEmptyData = (objectValue = {}) => {
  /* eslint-disable no-restricted-syntax */
  for (const [, value] of Object.entries(objectValue)) {
    if (value) {
      return false;
    }
  }
  /* eslint-enable no-restricted-syntax */

  return true;
};

export const displayDate = (
  timestamp,
  defaultValue = '-',
  format = 'dd/MM/yyyy',
) => {
  if (!timestamp) {
    return defaultValue;
  }

  if (!isValidDate(new Date(timestamp))) {
    return defaultValue;
  }

  return formatDate(new Date(timestamp), format);
};
